import { render, staticRenderFns } from "./GenericIcon.vue?vue&type=template&id=9300ddac&"
import script from "./GenericIcon.vue?vue&type=script&lang=js&"
export * from "./GenericIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports